import request from './request'

export const getProvinces = () => {
  return request({
    url: '/region/provinces',
    method: 'get'
  })
}

export const getCities = (provinceId) => {
  return request({
    url: '/region/cities',
    method: 'get',
    params: { province_id: provinceId }
  })
}

export const getDistricts = (cityId) => {
  return request({
    url: '/region/districts',
    method: 'get',
    params: { city_id: cityId }
  })
}
